<template>
  <div class="pts-gallery">
    <div class="pts-container">
      <h1>{{ $t('vehicles', 'Nos véhicules') }}</h1>
      <flickity ref="flickity" :options="flickityOptions">
        <div class="pts-gallery__image"><img src="../assets/gallery/1.jpg"/></div>
        <div class="pts-gallery__image"><img src="../assets/gallery/2.jpg"/></div>
        <div class="pts-gallery__image"><img src="../assets/gallery/3.jpg"/></div>
        <div class="pts-gallery__image"><img src="../assets/gallery/4.jpg"/></div>
        <div class="pts-gallery__image"><img src="../assets/gallery/5.jpg"/></div>
      </flickity>
    </div>
  </div>
</template>

<script>
import Flickity from 'vue-flickity'

export default {
  name: 'Gallery',
  components: { Flickity },
  data() {
    return {
      flickityOptions: {
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true,
        autoPlay: 5000,
        imagesLoaded: true
      }
    }
  },

  mounted() {
    this.$polyglot.extendLocales({
      'fr': {
        'vehicles': 'Nos véhicules'
      },
      'en': {
        'vehicles': 'Our vehicles'
      }
    })
  }
}
</script>

<style scoped>
.pts-gallery {
  width: 100%;
  padding-bottom: 50px;
  border-bottom: 1px solid #B3B3B3;
}

.pts-gallery .pts-gallery__image {
  width: 280px;
  height: 200px;
  overflow: hidden;
  text-align: center;
}

.pts-gallery img {
  height: 200px;
  width: auto;
  border-radius: 5px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, .12);
}
</style>



// WEBPACK FOOTER //
// src/components/Gallery.vue